import type { HttpErrorResponse } from '../../services/commonCheckout/types/HttpErrorResponse';
import { HttpStatus } from '../../utils/constants';
import { SessionInvalidDefaultProps } from '../session-invalid-screen/SessionInvalidDefaultProps';
import { SessionExpiredDefaultProps } from '../session-invalid-screen/SessionExpiredDefaultProps';
import { SessionCanceledDefaultProps } from '../session-invalid-screen/SessionCanceledDefaultProps';

import { ServerErrorDefaultProps } from './ServerErrorDefaultProps';
import type { SessionOutcomeConfig } from './types/SessionOutcomeConfig';

const SESSION_TIMEOUT_TITLE = 'SESSION_TIMEOUT';
const SESSION_CANCELED_TITLE = 'SESSION_CANCELED';

export const deriveFailureConfigFromHttpError = (
  httpErrorResponse?: HttpErrorResponse,
): SessionOutcomeConfig['failure'] => {
  if (!httpErrorResponse) return undefined;

  const isUnauthorizedError =
    httpErrorResponse.status.toString().trim() ===
    HttpStatus.UNAUTHORIZED.toString();

  const isSessionCanceledError =
    httpErrorResponse?.title === SESSION_CANCELED_TITLE;

  const isSessionExpiredError =
    httpErrorResponse?.title === SESSION_TIMEOUT_TITLE;

  let sessionErrorDefaultProps;

  if (isSessionExpiredError) {
    sessionErrorDefaultProps = SessionExpiredDefaultProps;
  } else if (isSessionCanceledError) {
    sessionErrorDefaultProps = SessionCanceledDefaultProps;
  } else {
    sessionErrorDefaultProps = SessionInvalidDefaultProps;
  }

  return {
    ...(isUnauthorizedError ||
    isSessionCanceledError ||
    isSessionExpiredError
      ? sessionErrorDefaultProps
      : ServerErrorDefaultProps),
    title: httpErrorResponse.detail,
  };
};
